module.exports = __webpack_public_path__ + "static/media/iconThree.cc5e120c.svg";